import { DateTime } from "luxon";
import React from "react";

import { TicketPropertyRow } from "./TicketPropertyRow";

interface CreatedFieldProps {
  /** ISO instant the ticket was created. */
  createdAt: string;
  /** Set when the bot filed the ticket (its source conversation); a member filed it otherwise. */
  botConversationId?: number | null;
}

/**
 * When the ticket was created, and by whom in the coarse sense (the bot, or a team member).
 * Read-only. Chuck, 2026-10-20: nothing in the ticket UI showed the creation time — the list shows
 * "last activity" and the only trace was the "created this ticket" line at the bottom of the
 * Activity feed. Member names are not hydrated in this panel yet (see the assignees TODO), so a
 * member-created ticket says "a team member" rather than guessing a name.
 */
export function CreatedField({ createdAt, botConversationId }: CreatedFieldProps): React.ReactElement {
  const when = DateTime.fromISO(createdAt);
  const label = when.isValid ? when.toLocal().toFormat("MM/dd/yyyy h:mm a") : "Unknown";
  const by = botConversationId ? "by the bot" : "by a team member";
  return (
    <TicketPropertyRow label="Created">
      <span
        className="px-2 py-0.5 text-sm text-black"
        title={when.isValid ? when.toLocal().toFormat("cccc, LLLL d, yyyy 'at' h:mm a ZZZZ") : undefined}
      >
        {label} <span className="text-grey-500">{by}</span>
      </span>
    </TicketPropertyRow>
  );
}
